import { z } from "@reflag/shared/utils/zod";

import { EnvironmentTypeSchema } from "../schemas/environmentTypeSchema";
import { booleanish } from "./booleanish";

export const API_URL = "http://localhost:3100/api";
export const REFLAG_PUBLISHABLE_KEY = "pub_loca_y7EAU00gyjmVriUQpIIHt7";
export const CLERK_PUBLISHABLE_KEY =
  "pk_test_dG9sZXJhbnQtY293LTE4LmNsZXJrLmFjY291bnRzLmRldiQ";
export const SETUP_DEMO_DATA = true;

export const RuntimeVariablesSchema = z.object({
  ENVIRONMENT: EnvironmentTypeSchema,

  SETUP_DEMO_DATA: booleanish.default(SETUP_DEMO_DATA),

  REFLAG_PUBLISHABLE_KEY: z
    .string()
    .min(12)
    .max(48)
    .default(REFLAG_PUBLISHABLE_KEY),

  GIT_COMMIT: z.string().min(6).max(128).optional(),
  CLERK_PUBLISHABLE_KEY: z
    .string()
    .min(8)
    .max(128)
    .default(CLERK_PUBLISHABLE_KEY),

  API_URL: z.string().url().default(API_URL),
  SENTRY_DSN: z.string().url().optional(),
  INTERCOM_APP_ID: z.string().min(1).max(64).optional(),
});

export type RuntimeVariablesInputType = z.input<typeof RuntimeVariablesSchema>;
export type RuntimeVariablesType = z.output<typeof RuntimeVariablesSchema>;
